/* eslint-disable no-dupe-keys */
export default {
  trigger: {
    name: '活动优惠奖励',
    // 属性（一般与对象内容匹配）
    prop: {
      name: '活动名',
      trigger_event: '触发事件',
      begin_time: '生效开始时间',
      end_time: '生效结束时间',
      status: '状态',
      reward_method: '奖励方式',
      per_trigger_times_limit: '每人参与次数上限',
      total_trigger_times_limit: '总参与次数上限',
      trigger_times: '参与次数',
      last_trigger_time: '最近参与时间',
      created_at: '创建时间',
      updated_at: '更新时间',
      charge_stations: '适用场站',
      rules: '奖励规则',
      service_provider: '运营商',
      description: '说明',
      valid_time_range: '有效时间',
      amount_gte: '金额≥',
      consumed_power_gte: '电量≥',
      award_type: '奖品',
      support_membership_point_reward: '会员积分翻倍权益',
      coupons_count: '优惠券数量',
      prizes_count: '奖品数量',
      continuity_days_gte: '连续打卡天数'
    },
    // Enum的属性
    trigger_events: {
      register: '用户注册',
      top_up: '用户充值',
      order_paid: '订单支付',
      station_comment: '电站点评',
      order_comment: '订单点评',
      checkin: '打卡签到',
      car_created: '绑定车牌',
      car_audit_passed: '认证车辆',
      product_order_paid: '商品订单支付'
    },
    statuses: {
      enabled: '可用',
      disabled: '不可用'
    },
    virtual_statuses: {
      in_progress: '进行中',
      pending: '待生效',
      expired: '已过期',
      // enabled: '已启用',
      disabled: '已禁用'
    },
    // 奖励类型
    award_types: {
      point: '积分',
      money: '现金',
      coupon: '优惠券',
      prize: '奖品',
      support_membership_point_reward: '会员积分翻倍'
    },
    reward_methods: {
      every_once: '自定义奖励规则',
      every_consumed_power: '按每度电',
      every_amount: '按每一元'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询活动名',
      input_description: 'APP不可见',
      input_limit_count: '输入限制数量'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      outcomes: '奖励记录'
    },
    // 标题
    titles: {
      base_info: '基本信息',
      condition_info: '条件约束',
      award: '活动奖励'
    },
    list_tabs: {
      in_progress: '进行中',
      all: '全部'
    },
    btn: {
      add_award: '添加奖励'
    },
    support_membership_point_rewards: {
      true: '会员享翻倍权益',
      false: '无会员权益'
    }
  }
}
